import Req from '../../$axios';

const serviceModule = {
  // 获取部门信息
  getuserlist(params) {
    return Req({
      url: 'user/getuserlist/',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  getTeamInfo(params) {
    return Req({
      url: 'statistic/department/',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  teamStatistics(params) {
    return Req({
      url: 'statistic/teamStatistics',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  myManagementAndDepartmentIndex(params) {
    return Req({
      url: 'departments/myManagementAndDepartmentIndex',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  addressBookDepartmentIndex(params) { // 通讯录部门列表
    return Req({
      url: 'departments/addressBookDepartmentIndex',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  addressBookUserIndex(params) { // 通讯录用户列表
    return Req({
      url: 'users/addressBookUserIndex',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  addressBookSearch(params) { // 通讯录搜索
    return Req({
      url: 'departments/addressBookSearch',
      method: 'get',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
};

export default {
  ...serviceModule
};
